import includes from 'lodash/includes';

import type { DetectorParams } from '../types';

/**
 * Detect the text channel
 */
export const isTextChannelFn = ({ firstUrl }: DetectorParams): boolean => {
  if (includes(firstUrl?.pathname, '/t/')) {
    return true;
  }

  return false;
};
